export default __webpack_public_path__ + "images/NK.397044e.png";